import { render, staticRenderFns } from "./VlSelect.vue?vue&type=template&id=46e5325d&scoped=true&"
import script from "./VlSelect.vue?vue&type=script&lang=js&"
export * from "./VlSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e5325d",
  null
  
)

export default component.exports